<div class="container">
  <div class="messenger-box">
    <div>
      <label for="facebook-id" class="input-label">Nhập Page ID tại đây:</label>
      <input
        id="facebook-id"
        class="input-field"
        placeholder="Nhập Page ID"
        nz-input
        [(ngModel)]="data_object.data.link"
        (blur)="updateOrAdd({staticdata: {link: data_object.data.link}})"
      />
    </div>
  </div>
</div>
